// extracted by mini-css-extract-plugin
export default {"br":"Bl","w80":"Cl","card":"El","wrapper":"Fl","fullView":"Gl","profilePic":"Hl","comment":"Il","animate":"Jl","shimmer":"Kl","square":"Ll"};
    if(module.hot) {
      // 1713361642088
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  